module.exports = __webpack_public_path__ + "img/12.12.BigBonus.062945ac.png";